import { Chat } from './components/Chat';

export function App() {
  return <Chat />;
}
